export default __webpack_public_path__ + "static/media/phone.2059f4a9.webp";